/** 是否展示小程序 */
export function isShowMiniapp(config: any) {
  return !!(config.appid || config.username);
};
